import { IsNotEmpty } from 'class-validator';

export class FileCreationDto {
  @IsNotEmpty()
  file!: File;
}
